import { Dialog, DialogContent } from "@/shadcn/ui/dialog";
import { Drawer, DrawerContent } from "@/shadcn/ui/drawer";

import { cn } from "@/lib/utils";
import { useMediaQuery } from "../common/hooks/useMediaQuery";

interface LocationSettingsModalOrDrawerProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  children: React.ReactNode;
}

export function LocationSettingsModalOrDrawer({
  isOpen,
  setIsOpen,
  children,
}: LocationSettingsModalOrDrawerProps) {
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const className = "p-6 flex flex-col gap-4";

  if (isDesktop) {
    return (
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent
          className={cn("sm:max-w-[425px] rounded-2xl", className)}
        >
          {children}
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Drawer open={isOpen} onOpenChange={setIsOpen}>
      <DrawerContent className={cn(className)}>{children}</DrawerContent>
    </Drawer>
  );
}
